import { SyncOutlined } from '@ant-design/icons';
import { Button, Select, Space } from 'antd';
import { FC, useState } from 'react';

import useSWRProductSuppliers from 'src/hooks/swr/useSWRProductSuppliers';

interface ProductSupplierSelectorProps {
  productSupplierId?: string;
  minWidth?: number;
  onProductSupplierChange?: (productSupplierId: string) => void;
}

const ProductSupplierSelector: FC<ProductSupplierSelectorProps> = ({
  productSupplierId,
  minWidth = 200,
  onProductSupplierChange,
}) => {
  const [selectedProductSupplierId, setSelectedProductSupplierId] = useState<string | undefined>(productSupplierId);
  const { productSuppliers, isLoading, refresh } = useSWRProductSuppliers([['deletedAt', '==', null]]);

  const options = productSuppliers
    ?.sort((a, b) => a.name.localeCompare(b.name))
    ?.map((productSupplier) => ({
      label: productSupplier.name,
      value: productSupplier._id,
    }));

  const handleProductSupplierChange = (value: string) => {
    setSelectedProductSupplierId(value);
    onProductSupplierChange?.(value);
  };

  return (
    <Space>
      <Select
        showSearch
        placeholder='거래처 선택'
        options={options}
        loading={isLoading}
        value={selectedProductSupplierId}
        onChange={handleProductSupplierChange}
        filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
        style={{ minWidth }}
      />
      <Button icon={<SyncOutlined style={{ color: 'var(--gray700)' }} />} onClick={refresh} loading={isLoading} />
    </Space>
  );
};

export default ProductSupplierSelector;
